<template>
    <div class="bg-surface-secondary w-100">
        <header class="bg-surface-primary border-bottom">
            <div class="container-fluid py-3">
                <div class="row align-items-center">
                    <div class="col">
                        <div class="d-flex align-items-center gap-4">
                            <div>
                                <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                            </div>
                            <div class="vr opacity-20 my-1"></div>
                            <div>
                                <h1 class="h4 ls-tight">Escaneo</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="py-6 bg-surface-secondary">
            <div class="container-fluid vstack gap-5">
                <div class="d-flex flex-column flex-md-row gap-3 justify-content-between">
                    <div class="d-flex gap-3 row">
                        <div class="col-md-4 px-0">
                            <div class="input-group input-group-sm input-group-inline">
                                <div class="input-group-prepend">
                                    <span class="input-group-text pe-2 text-sm"><i class="bi bi-search"></i></span>
                                </div>
                                <search v-model="deliver_route_id" autofocus item-text="id" item-value="id" childplaceholder="Seleccione o ingrese una ruta de entrega..." endpoint="/close/deliver-routes"/>
                            </div>
                        </div>
                        <div>
                            <button type="button" :disabled="!deliver_route_id" @click="FILTER()" class="btn btn-h px-3 btn-primary">
                                <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'filter'">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <span v-else>Filtrar</span>
                            </button>
                        </div>
                        <div>
                            <button type="button" :disabled="!deliver_route_id" @click="CLEAR()" class="btn btn-h px-3 btn-danger">
                                <span>Limpiar</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header bg-white">
                        <h5 class="me-auto">Escaneo</h5>
                    </div>
                    <div class="card-body" v-if="scan == true">
                        <div>
                            <form @submit.prevent="RECEIVE()" class="d-flex gap-3 row">
                                <div class="col-lg-11 col-sm-10 col-9 px-0">
                                    <div class="input-group input-group-inline">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text pe-2 text-sm">GV</span>
                                        </div>
                                        <input type="text" class="form-control" placeholder="Buscar..." ref="number" v-model="number">
                                    </div>
                                </div>
                                <div>
                                    <button type="submit" :disabled="!number" class="btn px-3 btn-primary">
                                        <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'destination'">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        <span v-else>Buscar</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="card-header bg-white" v-if="scan == true">
                        <h5 class="me-auto d-flex align-items-center justify-content-start gap-3">
                            Ruta de Entrega: #{{ data.id }} - {{ data.route.full_name}}. Imprimir: 
                            <button type="button" class="btn btn-h btn-neutral" @click="PRINT()">
                                <div class="spinner-border spinner-border-sm mb-0" role="status" v-if="print == 1">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <i class="bi bi-printer" v-else></i>
                            </button>
                        </h5>
                    </div>
                    <div class="card-body p-0">
                        <template v-if="data.packages.length > 0">
                            <v-data-table
                                :headers="headers"
                                :items="data.packages"
                                hide-default-footer
                                dense
                                :items-per-page="-1"
                                class="elevation-1 table-sm"
                                :item-class="ITEM_ROW_BACKGROUND">
                                <template v-slot:[`item.id`]="{ item, index }">
                                    {{ index + 1}}
                                </template>
                                <template v-slot:[`item.id`]="{ item }">
                                    <router-link
                                        :to="{ name: 'PackageUpdate', params: { id: item.id } }"
                                        class="text-decoration-none">
                                        {{ item.type }}{{ item.id }}
                                    </router-link>
                                </template>
                                <template v-slot:[`item.driver`]="{ item }">
                                    {{ data.driver ? data.driver.name : '' }}
                                </template>
                                <template slot="body.append">
                                    <tr>
                                        <td class="text-start"><span>Significado Colores:</span></td>
                                        <td class="text-start green"><span>Entregados</span></td>
                                        <td class="text-start"><span>Sin Escanear</span></td>
                                        <td class="text-start yellow"><span>En Inventario</span></td>
                                        <td class="text-start"></td>
                                        <td class="text-start"></td>
                                        <td class="text-start"></td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </template>
                        <p class="text-sm text-muted text-center mb-0 py-3" v-else>No hay resultados.</p>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: '',
            headers: [
                { text: 'No.', value: 'id' },
                { text: 'GVT', value: 'id' },
                { text: 'Sucursal Paquete', value: 'branch_office.name' },
                { text: 'Cliente', value: 'user.name' },
                { text: 'Chofer', value: 'driver' },
                { text: 'Descripción', value: 'description' },
                { text: 'No. Tracking', value: 'tracking' },
            ],
            scan: false,
            data: {
                id: '',
                route: { 
                    full_name: '',
                },
                packages: []
            },
            deliver_route_id: '',
            number: '',
            deliver_routes: [],
            count: 0,
            destination: 0,
            print: 0
        }
    },
    methods: {
        ITEM_ROW_BACKGROUND: function (item) {
            return item.state_id == 17 ? 'green text-white' : item.in_stock == 1 ? 'yellow' : ''
        },
        CLEAR: function(deliver_route_id = true){
            let vue = this
            vue.data = {
                packages: [],
            }
            if(deliver_route_id){
                vue.deliver_route_id = ''
            }
            vue.scan = false
        },
        FILTER: function(){
            let vue = this
            vue.CLEAR(false)
            vue.count++
            vue.loading = 'filter'
            if (vue.count == 1) {
                axios({ url: '/search/deliver-routes', method: 'POST', data: {deliver_route_id: vue.deliver_route_id} })
                    .then((resp) => {
                        vue.data = resp.data
                        vue.scan = true
                    })
                    .catch((err) => {
                        if (err.response.status === 402 || err.response.status === 404) {
                           let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                    })
                    .finally((resp) => {
                        vue.count = 0
                        vue.loading = ''
                        if(vue.$refs.number){
                            vue.$nextTick(() => vue.$refs.number.focus())
                        }
                    })
            }
        },
        RECEIVE: function(){
            let vue = this
            vue.destination++
            vue.loading = 'destination'
            if (vue.destination == 1) {
                let data = {
                    id: vue.number,
                    deliver_route_id: vue.data.id
                }
                axios({ url: '/receive/deliver-routes', method: 'POST', data: data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: 'Paquete escaneado con éxito', position: 'top-end', showConfirmButton: false, timer: 3000 })
                        let item = resp.data
                        let index = vue.data.packages.findIndex(e => e.id == item.id)
                        vue.data.packages[index].in_stock = item.in_stock
                        vue.number = ''
                    })
                    .catch((err) => {
                        if (err.response.status === 402 || err.response.status === 404) {
                           let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                    })
                    .finally((resp) => {
                        vue.destination = 0
                        vue.loading = ''
                        if(vue.$refs.number){
                            vue.$nextTick(() => vue.$refs.number.focus())
                        }
                    })
            }
        },
        PRINT: function(){
            let vue = this
            vue.print++
            if(vue.print == 1){
                axios({url: '/print/deliver-route/' + this.data.id + '/stock', method: 'GET', responseType: 'blob' })
                .then((response) => {
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(response.data)
                    link.target = '_blank'
                    link.rel = "noopener"
                    link.click()
                    vue.print = 0
                })
                .finally((resp)=>{
                    vue.print = 0
                })
            }
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/pages/delivery-routes/Scan.vue